module.exports = __webpack_public_path__ + "img/b533bea4280d229a72bc0479e0d2eeda.png";